import { render } from "./FabricAndPrint.vue?vue&type=template&id=57cd0592&scoped=true"
import script from "./FabricAndPrint.vue?vue&type=script&lang=js"
export * from "./FabricAndPrint.vue?vue&type=script&lang=js"

import "./FabricAndPrint.vue?vue&type=style&index=0&id=57cd0592&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cd0592"]])

export default __exports__